import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatManwon } from '../../../utils/formatKRW';

export interface PensionChartProps {
  averageMonthlyIncome: number;
  estimatedMonthlyPension: number;
}

export function PensionChart({
  averageMonthlyIncome,
  estimatedMonthlyPension,
}: PensionChartProps) {
  const barData = [
    { name: '현재 월 소득', value: averageMonthlyIncome, fill: '#6b7280' },
    { name: '예상 월 연금', value: estimatedMonthlyPension, fill: '#3b82f6' },
  ];

  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={barData} margin={{ top: 24, right: 8, bottom: 0, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
        <XAxis dataKey="name" axisLine={false} tickLine={false} style={{ fontSize: '0.75rem' }} />
        <YAxis
          tickFormatter={(v) => `${Math.round(v / 10000)}만`}
          axisLine={false}
          tickLine={false}
          style={{ fontSize: '0.6875rem' }}
          width={52}
        />
        <Tooltip formatter={((v: number) => [formatManwon(v), '금액']) as any} />
        <Legend />
        <ReferenceLine
          y={averageMonthlyIncome * 0.7}
          stroke="#ed6c02"
          strokeDasharray="4 4"
          label={{ value: '목표 대체율 70%', position: 'top', fill: '#ed6c02', fontSize: 12 }}
        />
        <Bar dataKey="value" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
